import { X } from 'lucide-react';

export default function BulkActionBar({ count, onSetActive, onSetDraft, onArchive, onDelete, onDeselect }) {
  const btnStyle = { background: 'rgba(255,255,255,.15)', border: 'none', padding: '6px 12px', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 12, fontFamily: 'inherit' };
  return (
    <div style={{
      position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
      background: '#3d2b1f', color: '#fff', borderRadius: 14, padding: '12px 20px',
      display: 'flex', alignItems: 'center', gap: 14, boxShadow: '0 8px 32px rgba(0,0,0,.25)',
      fontSize: 13, fontWeight: 700, zIndex: 200, fontFamily: "'Nunito',sans-serif",
    }}>
      <span>{count} selected</span>
      <div style={{ width: 1, height: 20, background: 'rgba(255,255,255,.2)' }} />
      <button onClick={onSetActive} style={{ ...btnStyle, color: '#c8ddd0' }}>Set Active</button>
      <button onClick={onSetDraft} style={{ ...btnStyle, color: '#fef3d8' }}>Set Draft</button>
      <button onClick={onArchive} style={{ ...btnStyle, color: '#ede3d5' }}>Archive</button>
      <button onClick={onDelete} style={{ ...btnStyle, background: 'rgba(220,53,69,.3)', color: '#ff8888' }}>Delete</button>
      <button onClick={onDeselect} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.6)', cursor: 'pointer', padding: 4, display: 'flex' }}><X size={16} /></button>
    </div>
  );
}
